<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.53488 5.75856C5.39554 7.28016 4 9.77944 4 12.6047C4 17.2413 7.75872 21 12.3953 21C17.032 21 20.7907 17.2413 20.7907 12.6047C20.7907 9.77944 19.3952 7.28016 17.2558 5.75856M12.3953 2V15.6977" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</template>
